import {load,getRef} from './common'

export function loadGroups() {
  return load('groups')
}

export function saveGroup({uid,group}) {
  let ref = getRef('groups')
  if(uid){
    ref.child(uid).set(group)
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/actions/groups.js
 **/